import classnames from 'classnames'

import _get from 'lodash/get'
import _last from 'lodash/last'

import Image from 'components/Image'
import Paragraph from 'components/Paragraph'

import Styled from './styled'

const stepIcon = '/assets/images/step.png'

const steps = [
  { no: 1, name: 'เลือกบริการ' },
  { no: 1, name: 'การจองบริการ ' },
  { no: 2, name: 'ระบุข้อมูลของท่าน' },
  { no: 2, name: 'เลือกวันเวลานัดหมาย' },
  { no: 3, name: 'ชำระค่าบริการ' },
]

export default function ServiceReservationSteps({ step = 0 }) {
  const totalStep = _last(steps).no
  const activeStep = _get(steps, step)
  const stepName = activeStep.name
  const stepNo = activeStep.no
  const activePercent = (100 / 3) * stepNo

  return (
    <Styled>
      <Image src={stepIcon} />

      <div className="bar-step-block">
        <Paragraph>
          {stepName} {`${stepNo} / ${totalStep}`}
        </Paragraph>
        <div className="bar-step">
          <div
            className={classnames('active-bar-step', { max: activePercent === 100 })}
            style={{ width: `${activePercent}%` }}
          />
        </div>
      </div>
    </Styled>
  )
}
